var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMusicSound(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3232 0.618494C13.4353 0.713496 13.5 0.853028 13.5 1V9.66667C13.5 11.0474 12.3807 12.1667 11 12.1667C9.61929 12.1667 8.5 11.0474 8.5 9.66667C8.5 8.28595 9.61929 7.16667 11 7.16667C11.5628 7.16667 12.0822 7.35264 12.5 7.66648V1.59023L5.5 2.7569V11L5.5 11.0016C5.49912 12.3816 4.38017 13.5 3 13.5C1.61929 13.5 0.5 12.3807 0.5 11C0.5 9.61929 1.61929 8.5 3 8.5C3.5628 8.5 4.08217 8.68597 4.5 8.99982V2.33334C4.5 2.08892 4.67671 1.88032 4.9178 1.84014L12.9178 0.506807C13.0628 0.482644 13.211 0.523492 13.3232 0.618494ZM12.5 9.66667C12.5 8.83824 11.8284 8.16667 11 8.16667C10.1716 8.16667 9.5 8.83824 9.5 9.66667C9.5 10.4951 10.1716 11.1667 11 11.1667C11.8284 11.1667 12.5 10.4951 12.5 9.66667ZM3 9.5C3.82843 9.5 4.5 10.1716 4.5 11C4.5 11.8284 3.82843 12.5 3 12.5C2.17157 12.5 1.5 11.8284 1.5 11C1.5 10.1716 2.17157 9.5 3 9.5Z",
    fill: "#414141"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusicSound);
export default __webpack_public_path__ + "static/media/musicSound.cfe23d58312a243c40c43ed8349e509e.svg";
export { ForwardRef as ReactComponent };